import axiosClient from 'config/axiosClient';

const _url = '/Api/TicketType';

const ticketTypeService = {
    getAll: () => {
        return axiosClient.post(_url + '/GetAll');
    },
    getPaging: (option: any) => {
        return axiosClient.post(_url + '/GetPaging', option);
    },
    getById: (id: string) => {
        return axiosClient.post(_url + '/GetById', { id });
    },
    save: (data: any) => {
        return axiosClient.post(_url + '/Save', data);
    },
    deleteTicketType: (id: string) => {
        return axiosClient.post(_url + '/Delete', { id });
    },
};

export default ticketTypeService;